import { HomeIcon, Compass, User, BookOpen, Camera, LayoutGrid, Wand2, Info, Mail, Shield, FileText, HelpCircle, Clock, LayoutDashboard, Globe, Edit, BookMarked, Coins, MapPin, Heart, Search, Users, Settings, Bell, CheckSquare, Receipt, Sparkles, Layers, Hotel, Zap, Activity, Lightbulb, Plane, Map } from "lucide-react";
import Index from "@/domains/travel-planning/pages/Index.jsx";
import Planner from "./pages/Planner.jsx";
import Login from "@/domains/user/pages/Login.jsx";
import Profile from "./pages/Profile.jsx";
import TripDetail from "./pages/TripDetail.jsx";
import Templates from "./pages/Templates.jsx";
import DiaryEditor from "./pages/DiaryEditor.jsx";
import Diaries from "./pages/Diaries.jsx";
import Album from "./pages/Album.jsx";
import TravelAI from "./pages/TravelAI.jsx";
import About from "./pages/About.jsx";
import Contact from "./pages/Contact.jsx";
import Privacy from "./pages/Privacy.jsx";
import Terms from "./pages/Terms.jsx";
import Guide from "./pages/Guide.jsx";
import FAQ from "./pages/FAQ.jsx";
import Changelog from "./pages/Changelog.jsx";
import NotFound from "./pages/NotFound.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Discover from "./pages/Discover.jsx";
import Travelogues from "./pages/Travelogues.jsx";
import TravelogueDetail from "./pages/TravelogueDetail.jsx";
import TravelogueEditor from "./pages/TravelogueEditor.jsx";
import Guides from "./pages/Guides.jsx";
import GuideDetail from "./pages/GuideDetail.jsx";
import PointsCenter from "./pages/PointsCenter.jsx";
import POIs from "./pages/POIs.jsx";
import POIDetail from "./pages/POIDetail.jsx";
import MyCollections from "./pages/MyCollections.jsx";
import SearchPage from "./pages/Search.jsx";
import Destinations from "./pages/Destinations.jsx";
import DestinationDetail from "./pages/DestinationDetail.jsx";
import Community from "./pages/Community.jsx";
import UserProfile from "./pages/UserProfile.jsx";
import FollowList from "./pages/FollowList.jsx";
import SettingsPage from "./pages/Settings.jsx";
import Notifications from "./pages/Notifications.jsx";
import Scenes from "./pages/Scenes.jsx";
import Checklist from "./pages/Checklist.jsx";
import Expense from "./pages/Expense.jsx";
import Poses from "./pages/Poses.jsx";
import TripStudio from "./pages/TripStudio.jsx";
import HotelIntelligence from "./pages/HotelIntelligence.jsx";
import LiveTrip from "./pages/LiveTrip.jsx";
import DecisionTrace from "./pages/DecisionTrace.jsx";
// ===== 新增产品页面 =====
import ExplorePage from "./pages/Explore.jsx";
import InspirationPage from "./pages/Inspiration.jsx";
import MyTravelPage from "./pages/MyTravel.jsx";
import PlannerHistoryPage from "./pages/PlannerHistory.jsx";

export const navItems = [
  { title: "首页", to: "/", icon: <HomeIcon className="h-4 w-4" />, page: <Index /> },
  { title: "AI旅行规划", to: "/planner", icon: <Sparkles className="h-4 w-4" />, page: <Planner /> },
  { title: "AI行程历史", to: "/planner/history", icon: <Clock className="h-4 w-4" />, page: <PlannerHistoryPage /> },
  { title: "探索目的地", to: "/explore", icon: <MapPin className="h-4 w-4" />, page: <ExplorePage /> },
  { title: "旅行灵感", to: "/inspiration", icon: <Lightbulb className="h-4 w-4" />, page: <InspirationPage /> },
  { title: "我的旅行", to: "/my-travel", icon: <Plane className="h-4 w-4" />, page: <MyTravelPage /> },
  { title: "AI工作台", to: "/trip-studio", icon: <Sparkles className="h-4 w-4" />, page: <TripStudio /> },
  { title: "AI旅行攻略", to: "/travel-ai", icon: <Wand2 className="h-4 w-4" />, page: <TravelAI /> },
  { title: "探索", to: "/discover", icon: <Compass className="h-4 w-4" />, page: <Discover /> },
  { title: "场景模板", to: "/templates", icon: <LayoutGrid className="h-4 w-4" />, page: <Templates /> },
  { title: "旅行日记", to: "/diaries", icon: <BookOpen className="h-4 w-4" />, page: <Diaries /> },
  { title: "日记编辑器", to: "/diary/new", icon: <BookOpen className="h-4 w-4" />, page: <DiaryEditor /> },
  { title: "日记编辑", to: "/diary/:id", icon: <BookOpen className="h-4 w-4" />, page: <DiaryEditor /> },
  { title: "打卡相册", to: "/album", icon: <Camera className="h-4 w-4" />, page: <Album /> },
  { title: "登录", to: "/login", icon: <User className="h-4 w-4" />, page: <Login /> },
  { title: "个人中心", to: "/profile", icon: <User className="h-4 w-4" />, page: <Profile /> },
  { title: "行程详情", to: "/trip/:id", icon: <Compass className="h-4 w-4" />, page: <TripDetail /> },
  { title: "关于我们", to: "/about", icon: <Info className="h-4 w-4" />, page: <About /> },
  { title: "联系我们", to: "/contact", icon: <Mail className="h-4 w-4" />, page: <Contact /> },
  { title: "隐私政策", to: "/privacy", icon: <Shield className="h-4 w-4" />, page: <Privacy /> },
  { title: "服务条款", to: "/terms", icon: <FileText className="h-4 w-4" />, page: <Terms /> },
  { title: "使用指南", to: "/guide", icon: <BookOpen className="h-4 w-4" />, page: <Guide /> },
  { title: "常见问题", to: "/faq", icon: <HelpCircle className="h-4 w-4" />, page: <FAQ /> },
  { title: "更新日志", to: "/changelog", icon: <Clock className="h-4 w-4" />, page: <Changelog /> },
  { title: "数据中心", to: "/dashboard", icon: <LayoutDashboard className="h-4 w-4" />, page: <Dashboard /> },
  { title: "发现", to: "/discover", icon: <Compass className="h-4 w-4" />, page: <Discover /> },
  { title: "旅行游记", to: "/travelogues", icon: <Globe className="h-4 w-4" />, page: <Travelogues /> },
  { title: "游记详情", to: "/travelogue/:id", icon: <BookOpen className="h-4 w-4" />, page: <TravelogueDetail /> },
  { title: "写游记", to: "/travelogues/new", icon: <Edit className="h-4 w-4" />, page: <TravelogueEditor /> },
  { title: "游记编辑", to: "/travelogue/:id/edit", icon: <Edit className="h-4 w-4" />, page: <TravelogueEditor /> },
  { title: "旅行攻略", to: "/guides", icon: <BookMarked className="h-4 w-4" />, page: <Guides /> },
  { title: "攻略详情", to: "/guide/:id", icon: <BookMarked className="h-4 w-4" />, page: <GuideDetail /> },
  { title: "积分中心", to: "/points", icon: <Coins className="h-4 w-4" />, page: <PointsCenter /> },
  { title: "景点探索", to: "/pois", icon: <MapPin className="h-4 w-4" />, page: <POIs /> },
  { title: "景点详情", to: "/poi/:id", icon: <MapPin className="h-4 w-4" />, page: <POIDetail /> },
  { title: "我的收藏", to: "/my-collections", icon: <Heart className="h-4 w-4" />, page: <MyCollections /> },
  { title: "全局搜索", to: "/search", icon: <Search className="h-4 w-4" />, page: <SearchPage /> },
  { title: "目的地", to: "/destinations", icon: <Globe className="h-4 w-4" />, page: <Destinations /> },
  { title: "目的地详情", to: "/destination/:id", icon: <Globe className="h-4 w-4" />, page: <DestinationDetail /> },
  { title: "社区", to: "/community", icon: <Users className="h-4 w-4" />, page: <Community /> },
  { title: "用户主页", to: "/user/:id", icon: <User className="h-4 w-4" />, page: <UserProfile /> },
  { title: "粉丝列表", to: "/user/:id/followers", icon: <Users className="h-4 w-4" />, page: <FollowList /> },
  { title: "关注列表", to: "/user/:id/following", icon: <Users className="h-4 w-4" />, page: <FollowList /> },
  { title: "设置", to: "/settings", icon: <Settings className="h-4 w-4" />, page: <SettingsPage /> },
  { title: "通知", to: "/notifications", icon: <Bell className="h-4 w-4" />, page: <Notifications /> },
  { title: "精选场景", to: "/scenes", icon: <Sparkles className="h-4 w-4" />, page: <Scenes /> },
  { title: "旅行待办", to: "/checklist", icon: <CheckSquare className="h-4 w-4" />, page: <Checklist /> },
  { title: "旅行记账", to: "/expense", icon: <Receipt className="h-4 w-4" />, page: <Expense /> },
  { title: "拍照姿势", to: "/poses", icon: <Camera className="h-4 w-4" />, page: <Poses /> },
  { title: "酒店决策引擎", to: "/hotel-intelligence", icon: <Hotel className="h-4 w-4" />, page: <HotelIntelligence /> },
  { title: "实时旅行模式", to: "/live-trip", icon: <Zap className="h-4 w-4" />, page: <LiveTrip /> },
  { title: "决策链路追踪", to: "/decision-trace", icon: <Layers className="h-4 w-4" />, page: <DecisionTrace /> },
  { title: "404", to: "*", icon: <HelpCircle className="h-4 w-4" />, page: <NotFound /> },
];
